// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-paginator .page-counter-label {
  font-weight: 500;
}
.fi-paginator .mat-mdc-button.mdc-button {
  border-radius: 10px;
}
.fi-paginator .mat-mdc-button,
.fi-paginator .mdc-icon-button {
  opacity: 1;
  transition: opacity 0.2s;
  font-weight: 500;
}
.fi-paginator .mat-mdc-button.button-hidden,
.fi-paginator .mdc-icon-button.button-hidden {
  pointer-events: none;
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-paginator/fi-paginator.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAEI;EACI,mBAAA;AAAR;AAEI;;EAEI,UAAA;EACA,wBAAA;EACA,gBAAA;AAAR;AACQ;;EACI,oBAAA;EACA,UAAA;AAEZ","sourcesContent":[".fi-paginator {\r\n    .page-counter-label {\r\n        font-weight: 500;\r\n    }\r\n    .mat-mdc-button.mdc-button {\r\n        border-radius: 10px;\r\n    }\r\n    .mat-mdc-button,\r\n    .mdc-icon-button {\r\n        opacity: 1;\r\n        transition: opacity 0.2s;\r\n        font-weight: 500;\r\n        &.button-hidden {\r\n            pointer-events: none;\r\n            opacity: 0;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
